import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path, Circle } from 'react-native-svg';

const MB_SVG_Smile = React.memo(
  (props: {
    /**
     * The size of the component.
     */
    size?: number;

    /**
     * The color of the component.
     */
    color?: string;

    /**
     * The style of the component's container.
     */
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.size ?? 24}
          height={props.size ?? 24}
          viewBox="0 0 24 24"
          fill="none"
          stroke={props.color ?? 'white'}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <Circle cx={12} cy={12} r={10} />
          <Path d="M8 14s1.5 2 4 2 4-2 4-2" />
          <Path d="M9 9L9.01 9" />
          <Path d="M15 9L15.01 9" />
        </Svg>
      </View>
    );
  }
);

export { MB_SVG_Smile };
